import React from "react";

const Spinner = () => {
  return (
    <div>
      <div class="loader"></div>
    </div>
  );
};

export default Spinner;
